import { ShockWaveEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const ShockWave = wrapEffect(ShockWaveEffect)
